"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "championships", {
    enumerable: true,
    get: function() {
        return championships;
    }
});
const championships = [
    {
        id: "wwe-title",
        name: "WWE Championship",
        wrestlerIds: [
            "cody-rhodes"
        ],
        brandIds: [
            "smackdown",
            "raw"
        ],
        gender: "MALE",
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2024/04/TITLE_04192023gd_0062_Fin--b4ea60da7626c3ce7fe770d2f0955917.png",
        color: "#ffffff",
        backgroundColor: "#353331",
        minPoints: 85,
        maxPoints: 101,
        rank: 1
    },
    {
        id: "womens-world-championship",
        name: "Women's World Championship",
        wrestlerIds: [
            "becky-lynch"
        ],
        brandIds: [
            "raw"
        ],
        color: "#fff",
        gender: "FEMALE",
        image: "//www.wwe.com/f/styles/wwe_16_9_l/public/all/2023/06/TITLE_04212023gd_0006_Fin--39727c5972135200bd8983992c1424e3.png",
        backgroundColor: "#a58f7e",
        minPoints: 70,
        maxPoints: 100,
        rank: 5
    },
    {
        id: "smackdown-tag",
        name: "WWE Tag Team Championship",
        brandIds: [
            "smackdown"
        ],
        wrestlerIds: [
            "grayson-waller",
            "austin-theory"
        ],
        holders: 2,
        image: "//www.wwe.com/f/styles/wwe_16_9_xs/public/all/2016/09/Smackdown_Tag_Team_Championship--56b4c22440c69722801b765c851ef01f.png",
        backgroundColor: "#153863",
        color: "#ffffff",
        gender: "MALE",
        minPoints: 70,
        maxPoints: 100,
        rank: 15
    },
    {
        id: "ic",
        name: "Intercontinental Championship",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "sami-zayn"
        ],
        gender: "MALE",
        color: "#dbceb8",
        image: "//www.wwe.com/f/styles/wwe_16_9_xs/public/all/2019/11/_Intercontinental_Title_Belts_1920x1080_updated--7d94c38bf0d90f5cb2f3bad36490dd70.png",
        backgroundColor: "#000",
        minPoints: 70,
        maxPoints: 95,
        rank: 10
    },
    {
        id: "world-heavyweight",
        name: "World Heavyweight Championship",
        gender: "MALE",
        backgroundColor: "#666",
        wrestlerIds: [
            "damian-priest"
        ],
        brandIds: [
            "raw"
        ],
        color: "#ffffff",
        image: "//www.wwe.com/f/styles/wwe_16_9_l/public/all/2023/05/WWE_World_Championship--3f7deec341d4257875929ee8ab140834.png",
        minPoints: 80,
        maxPoints: 100,
        rank: 4
    },
    {
        id: "womens-championship",
        name: "WWE Women's Championship",
        wrestlerIds: [
            "bayley"
        ],
        brandIds: [
            "smackdown"
        ],
        color: "#ffffff",
        gender: "FEMALE",
        startDate: new Date("Aug 05, 2023"),
        backgroundColor: "#dab477",
        image: "//www.wwe.com/f/styles/wwe_16_9_xxs/public/all/2023/06/TITLE_04192023gd_0036_Fin--9e463b392bb67de44f5449c0c1103ccc.png",
        minPoints: 80,
        maxPoints: 100,
        rank: 6
    },
    {
        id: "us",
        name: "US Championship",
        wrestlerIds: [
            "logan-paul"
        ],
        brandIds: [
            "smackdown"
        ],
        gender: "MALE",
        image: "//www.wwe.com/f/styles/wwe_16_9_xs/public/all/2020/10/WWE_US_Championship--8a7032700a1cafff3403b6192157f15c.png",
        color: "#fff",
        backgroundColor: "#253a73",
        rank: 12,
        minPoints: 0,
        maxPoints: 90
    },
    {
        id: "aew-world-tag",
        name: "World Tag Championship",
        gender: "MALE",
        brandIds: [
            "dynamite",
            "collision"
        ],
        wrestlerIds: [
            "big-bill",
            "ricky-starks"
        ],
        holders: 2,
        minPoints: 70,
        maxPoints: 100
    },
    {
        id: "nxt-mens",
        name: "NXT Mens Championship",
        gender: "MALE",
        wrestlerIds: [
            "ilja-dragunov"
        ],
        brandIds: [
            "nxt"
        ],
        minPoints: 50,
        maxPoints: 95,
        image: "//www.wwe.com/f/styles/wwe_16_9_xxs/public/all/2022/04/NXT_Championship--7d8ea4d925fe43df5a8f0df6f0ba7e3d.png",
        backgroundColor: "#27211f",
        rank: 23,
        color: "#ffffff"
    },
    {
        id: "nxt-womens",
        name: "NXT Womens Championship",
        wrestlerIds: [
            "roxanne-perez"
        ],
        gender: "FEMALE",
        brandIds: [
            "nxt"
        ],
        minPoints: 70,
        maxPoints: 100,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2017/04/NXT_Womens_Championship--934970350d445835eff37fee38acb2a0.png",
        backgroundColor: "#e0ddde"
    },
    {
        id: "na",
        name: "North American Championship",
        gender: "MALE",
        brandIds: [
            "nxt"
        ],
        wrestlerIds: [
            "oba-femi"
        ],
        minPoints: 50,
        maxPoints: 85,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2018/04/NXT_North_American_Championship--ce0883c1531cfc9330a5a50c8e82b44d.png",
        backgroundColor: "#5d2b24",
        color: "#fff"
    },
    {
        id: "nxt-tag",
        name: "NXT Tag Championship",
        gender: "MALE",
        brandIds: [
            "nxt"
        ],
        wrestlerIds: [
            "bron-breakker",
            "corbin"
        ],
        minPoints: 60,
        maxPoints: 100,
        holders: 2,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2017/04/NXT_Tag_Team--ff5b24fcb35964613e5d0cb6f7e82e8a.png",
        backgroundColor: "#27211f",
        color: "#ffffff",
        rank: 25
    },
    {
        id: "raw-tag",
        name: "World Tag Team Championship",
        wrestlerIds: [
            "the-miz",
            "r-truth"
        ],
        gender: "MALE",
        brandIds: [
            "raw"
        ],
        holders: 2,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2024/04/TITLES_03282024gd_0349_cropped_Fin_revisedA--4e2365ba0473f4c396c17b990a1950c5.png",
        backgroundColor: "#8f273a",
        color: "#ffffff",
        minPoints: 60,
        maxPoints: 100,
        rank: 20
    },
    {
        id: "uni-world",
        name: "Universal Championship",
        gender: "MALE",
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2019/11/Universal_Championship_SD--384d68e1f2cff0dc98447b52a360bd0c.png",
        color: "#ffffff",
        backgroundColor: "#28356f",
        minPoints: 80,
        maxPoints: 101,
        retired: true,
        rank: 10
    },
    // {
    //   id: 'aew-world-tag',
    //   name: 'World Tag Team Championship',
    //   wrestlerIds: ['mjf'],
    //   gender: 'MALE',
    //   brandIds: ['dynamite', 'collision'],
    //   "image": "//www.shopaew.com/pub/media/catalog/product/a/e/aew1865-1_1_3_2.png",
    //   backgroundColor: '#000',
    //   color: '#fff',
    //   minPoints: 90,
    //   maxPoints: 100,
    //   rank: 7
    // },
    {
        id: "aew-world-trios",
        name: "World Trios Championship",
        "image": "//www.shopaew.com/pub/media/catalog/product/a/e/aew3476-1_1.png",
        gender: "MALE",
        brandIds: [
            "dynamite",
            "collision"
        ],
        backgroundColor: "#000",
        color: "#fff",
        minPoints: 90,
        maxPoints: 100,
        rank: 7
    },
    {
        id: "aew-womens-world",
        name: "Womens World Championship",
        wrestlerIds: [
            "toni-storm"
        ],
        gender: "FEMALE",
        backgroundColor: "#000",
        brandIds: [
            "dynamite"
        ],
        color: "#fff",
        minPoints: 80,
        maxPoints: 100,
        rank: 4
    },
    {
        id: "tbs",
        name: "TBS Championship",
        wrestlerIds: [
            "julia-hart"
        ],
        gender: "FEMALE",
        backgroundColor: "#000",
        brandIds: [
            "dynamite",
            "collision"
        ],
        color: "#fff",
        minPoints: 80,
        maxPoints: 100,
        rank: 4
    },
    {
        id: "tnt",
        name: "TNT Championship",
        wrestlerIds: [
            "adam-copeland"
        ],
        "image": "//www.shopaew.com/pub/media/catalog/product/a/e/aew2733-1_1.png",
        backgroundColor: "#2c2624",
        color: "#fff",
        brandIds: [
            "collision",
            "dynamite"
        ],
        minPoints: 80,
        maxPoints: 100,
        rank: 5
    },
    {
        id: "international",
        name: "International Championship",
        brandIds: [
            "dynamite"
        ],
        minPoints: 80,
        maxPoints: 100,
        color: "#fff",
        backgroundColor: "#000",
        rank: 3
    },
    {
        id: "wwe-womens-tag-team",
        name: "Womens Tag Championship",
        brandIds: [
            "raw",
            "smackdown"
        ],
        rank: 30,
        holders: 2,
        color: "#766665",
        backgroundColor: "#fff",
        gender: "FEMALE",
        wrestlerIds: [
            "asuka",
            "kairi-sane"
        ],
        image: "//www.wwe.com/f/styles/wwe_16_9_xs/public/all/2019/02/Womens_Tag_Team_Championship1--ddc29f86d386b1d56cc2cdbc8c876e15.png",
        minPoints: 60,
        maxPoints: 90
    },
    {
        id: "millionaire",
        name: "Million Dollar Championship",
        backgroundColor: "#6b4d28",
        color: "#faf1eb",
        gender: "MALE",
        brandIds: [
            "hall-of-fame"
        ],
        minPoints: 70,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2021/07/Million_Dollar_Title_06152021cg_004_Crop_(1)--ec0511481c4c937f38ab3c9f0e3e4e3e.png"
    },
    {
        id: "heritage-cup",
        name: "Heritage Cup",
        gender: "MALE",
        brandIds: [
            "nxt"
        ],
        rank: 40,
        color: "#fff",
        backgroundColor: "#000",
        minPoints: 60,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_16_9_l/public/all/2020/12/UK_Heritage_Cup--3d9643eed932bafc351491aa269c0449.png"
    },
    {
        id: "world-mens",
        name: "World Heavyweight Championship",
        brandIds: [
            "wcw",
            "hall-of-fame"
        ],
        gender: "MALE",
        minPoints: 80,
        maxPoints: 95,
        color: "#fff",
        backgroundColor: "#000",
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt_Retired/WWE_Heavyweight.png"
    },
    {
        id: "divas",
        name: "Divas Championship",
        backgroundColor: "#9d3d5b",
        color: "#ffffff",
        brandIds: [
            "hall-of-fame"
        ],
        gender: "FEMALE",
        minPoints: 60,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt/Divas_Championship.png"
    },
    {
        id: "european",
        name: "European Championship",
        brandIds: [
            "hall-of-fame"
        ],
        gender: "MALE",
        minPoints: 60,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt_Retired/WWE_European_Championship.png"
    },
    {
        id: "cruiserweight-light",
        name: "Cruiserweight Championship",
        brandIds: [
            "hall-of-fame"
        ],
        gender: "MALE",
        minPoints: 60,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt_Retired/WWE_Cruiserweight_Championship.png"
    },
    {
        id: "hardcore",
        name: "Hardcore Championship",
        backgroundColor: "#ab6b51",
        brandIds: [
            "hall-of-fame"
        ],
        color: "#faf1eb",
        gender: "INTERGENDER",
        minPoints: 60,
        maxPoints: 90,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt_Retired/WWE_Hardcore_Championship.png"
    },
    {
        id: "hardcore-world",
        name: "ECW World Championship",
        brandIds: [
            "ecw-world"
        ],
        gender: "INTERGENDER",
        minPoints: 60,
        maxPoints: 90,
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/championship/Belt_Retired/ECW_World_Heavyweight_Championship.png",
        backgroundColor: "#27211f",
        color: "#ffffff"
    },
    {
        id: "mitb",
        brandIds: [
            "raw",
            "smackdown"
        ],
        name: "MITB",
        gender: "INTERGENDER",
        color: "#fff",
        backgroundColor: "#004800",
        rank: 40,
        minPoints: 60,
        maxPoints: 80,
        image: "//www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2018/06/20180608_MITB_2018_Logo--7c8ce12e113e0c49b7e8dbae32c388e4.png"
    },
    {
        id: "roh-world-champion",
        name: "ROH World Champion",
        brandIds: [
            "roh"
        ],
        wrestlerIds: [
            "eddie-kingston"
        ],
        gender: "MALE",
        color: "#fff",
        backgroundColor: "#000"
    },
    {
        id: "roh-womens-world-champion",
        name: "ROH Womens World Champion",
        brandIds: [
            "roh"
        ],
        wrestlerIds: [
            "athena"
        ],
        gender: "FEMALE",
        color: "#fff",
        backgroundColor: "#000"
    },
    {
        id: "roh-world-tag-champions",
        name: "ROH World Tag Team Champions",
        brandIds: [
            "roh"
        ],
        wrestlerIds: [
            "mjf",
            "adam-cole"
        ],
        gender: "MALE",
        color: "#fff",
        backgroundColor: "#000"
    },
    {
        id: "roh-pure-champion",
        name: "ROH Pure Champion",
        brandIds: [
            "roh"
        ],
        wrestlerIds: [
            "wheeler-yuta"
        ],
        gender: "MALE",
        color: "#fff",
        backgroundColor: "#000"
    }
];
